import { Repository, EntityRepository } from "typeorm";
import { RmEvaluation } from "./rm-evaluation.entity";

@EntityRepository(RmEvaluation)
export class RmEvaluationRepository extends Repository<RmEvaluation>{

    async getRmEvalData(grnItemId: number): Promise<any>{
        console.log(grnItemId);
        const entity =await this.createQueryBuilder("RmEvaluation")
        .leftJoinAndSelect('RmEvaluation.RmEvalSamplesInfo', 'RmEvalSamplesInfo')
        .where(`RmEvaluation.grnItemId=${grnItemId}`)
        .getOne();
        console.log(entity);
        return entity;
    }
}